import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Landing.css';

const Landing: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="landing-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              {t('landing.heroTitle')}
            </h1>
            <p className="hero-subtitle">
              {t('landing.heroSubtitle')}
            </p>
            <div className="hero-actions">
              <Link to="/signup" className="btn btn-primary btn-large">
                {t('landing.getStarted')}
              </Link>
              <Link to="/signin" className="btn btn-secondary btn-large">
                {t('landing.signIn')}
              </Link>
            </div>
          </div>
          <div className="hero-image">
            <div className="snooker-illustration">
              🎱
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">
            {t('landing.featuresTitle')}
          </h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>{t('landing.feature1Title')}</h3>
              <p>{t('landing.feature1Description')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>{t('landing.feature2Title')}</h3>
              <p>{t('landing.feature2Description')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👥</div>
              <h3>{t('landing.feature3Title')}</h3>
              <p>{t('landing.feature3Description')}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏆</div>
              <h3>{t('landing.feature4Title')}</h3>
              <p>{t('landing.feature4Description')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section className="how-it-works-section">
        <div className="container">
          <h2 className="section-title">
            {t('landing.howItWorksTitle')}
          </h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>{t('landing.step1Title')}</h3>
                <p>{t('landing.step1Description')}</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>{t('landing.step2Title')}</h3>
                <p>{t('landing.step2Description')}</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>{t('landing.step3Title')}</h3>
                <p>{t('landing.step3Description')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>{t('landing.ctaTitle')}</h2>
            <p>{t('landing.ctaDescription')}</p>
            <div className="cta-actions">
              <Link to="/signup" className="btn btn-primary btn-large">
                {t('landing.startPlaying')}
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>{t('landing.footer.about')}</h4>
              <p>{t('landing.footer.aboutDescription')}</p>
            </div>
            <div className="footer-section">
              <h4>{t('landing.footer.features')}</h4>
              <ul>
                <li>{t('landing.footer.gameTracking')}</li>
                <li>{t('landing.footer.statistics')}</li>
                <li>{t('landing.footer.clubs')}</li>
                <li>{t('landing.footer.tournaments')}</li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>{t('landing.footer.getStarted')}</h4>
              <div className="footer-links">
                <Link to="/signup">{t('landing.footer.signUp')}</Link>
                <Link to="/signin">{t('landing.footer.signIn')}</Link>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Snooker App. {t('landing.footer.rights')}</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
